
import { MOCK_FILES, MOCK_CONTENT } from '../constants';
import { ArchiveFile } from '../types';

export const getMockFiles = (): ArchiveFile[] => {
    return MOCK_FILES;
};

export const getMockContent = (id: string): string | null => {
    return MOCK_CONTENT[id] || null;
};

export const getLegacyOverrides = (): Record<string, string> => {
    return {};
};

export const saveLegacyOverrides = (content: Record<string, string>) => {
    console.log("Legacy content save skipped (persistence disabled).");
};

export const saveMockFile = (file: ArchiveFile): boolean => {
    console.log("Mock file save skipped (persistence disabled).");
    return true;
};

export const saveMockContent = (id: string, html: string): boolean => {
    console.log("Mock content save skipped (persistence disabled).");
    return true;
};

export const deleteMockFile = (id: string) => {
    console.log("Mock delete skipped (persistence disabled).");
};

export const resetMocks = () => {
    console.log("Mock reset skipped.");
};
